import Stats from "stats.js"
import Keyb from "keyb"
import Poin from "poin"
import App from "@frog/source/models/App.js"

import games from "@frog/source/data/games/index.js"
import Stage from "@frog/source/models/Stage.js"
import Unit from "@frog/source/models/Unit.js"

import Loop from "@frog/source/utility/Loop.js"
//import Audiomix from "@frog/source/juice/Audiomix.js"

import shortid from "shortid"

// import Sleep from "@frog/source/utility/Sleep.js"

const dev = new class Dev {
    constructor() {
        this.isAllyDeathEnabled = true
        this.isAllyCollisionEnabled = true

        this.areDevPanelsOpen = false
        this.inProtoMode = false

        this.unitsFile = undefined
        this.selectedTemplate = undefined
        this.lastEmptyPositionClicked = undefined
        this.haveProtounitsBeenModified = false
        this.havePlayunitsBeenModified = false

        this.previousProtoUnits = []
        this.nextProtoUnits = []
        this.loadedProtostage = undefined

        this.isEnabled = false
        if(window.location.hostname == "localhost"
        || window.location.hostname == "127.0.0.1"
        || window.location.hostname.endsWith(".github.io")) {
            this.isEnabled = true
            if(window.location.search != "?production/") {
                this.inProtoMode = true
                this.areDevPanelsOpen = true
            }
        }

        if(this.isEnabled != true) return

        // Profiling
        this.stats = new Stats()
        this.stats.dom.style.position = "absolute"
        this.stats.dom.style.display = "flex"
        this.stats.dom.style.zIndex = -1
        Object.values(this.stats.dom.children).forEach((child) => child.style = "block")
        this.stats.dom.addEventListener("click", (event) => event.stopPropagation(), true)
        document.body.appendChild(this.stats.dom)

        // // Testing
        // import(/* webpackChunkName: "test.js" */"@frog/source/test.js")
        // import("@frog/source/utility/Testrecord.js")
        // Sleep(20 * 1000).then(() => import(/* webpackChunkName: "test.js" */"@frog/source/test.js"))
        // Sleep(2 * 1000).then(() => import(/* webpackChunkName: "test.js" */"@frog/source/test.js"))
        // require("@frog/source/test.js")
        // Sleep(1000).then(() => import("@frog/source/test.js"))
        // import("@frog/source/test.js")
        // import(/* webpackChunkName: "test.js" */"@frog/source/test.js")
    }
    // === Update Functions === //
    atStartOfLoop() {
        if(this.isEnabled != true) return

        if(this.stats != undefined) {
            this.stats.begin()
        }

        if(this.loadedProtostage == undefined
        && App.game?.slug != undefined) {
            this.loadedProtostage = games[App.game.slug].chapters[App.game.chapter.slug].stage
        }

        if(Keyb.wasJustPressed("-", Loop.delta.ms)) {
            this.areDevPanelsOpen = !this.areDevPanelsOpen
        }

        if(Keyb.wasJustPressed("=", Loop.delta.ms)) {
            this.inProtoMode = !this.inProtoMode
        }

        if(Keyb.wasJustPressed("<escape>", Loop.delta.ms)
        || Keyb.wasJustPressed("<backspace>", Loop.delta.ms)
        || Keyb.wasJustPressed("<delete>", Loop.delta.ms)
        || Poin.wasJustPressed("secondary", true, Loop.delta.ms)) {
            this.selectedTemplate = undefined
        }

        if(Keyb.wasJustPressed("F7", Loop.delta.ms)) {
            App.game.chapter.killAllEnemies()
        }

        if(Keyb.wasJustPressed("<backspace>", Loop.delta.ms)
        || Keyb.wasJustPressed("<delete>", Loop.delta.ms)) {
            this.deleteSelectedUnit()
        }
    }
    atEndOfLoop() {
        if(this.stats != undefined) {
            if(this.isEnabled != true) return
            this.stats.end()
        }
    }
    // === Filesaving Functions === //
    saveUnitsToFile() {
        this.unitFileWriting(this.loadedProtostage.units)
        if(this.havePlayunitsBeenModified == true) {
            window.alert("Edits have been made to the playtest units. These will not be saved")
        }
    }
    autosaveUnitsToFile() {
        if(this.unitsFile != undefined) {
            this.saveUnitsToFile()
        }
    }
    async unitFileWriting(saveObject) {

        if(this.unitsFile == undefined) {
            this.unitsFile = await window.showSaveFilePicker({
                suggestedName: 'units.json',
                types: [
                    {
                        description: "JSON Files",
                        accept: {
                            "text/*": [".json"],
                        },
                    },
                ]
            });
        }

        const writable = await this.unitsFile.createWritable()
        await writable.write(JSON.stringify(saveObject,undefined,4))
        await writable.close()
    }
    // === Clipboard Functions === //
    writeToClipboard(clippedUnit) {
        navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
            if (result.state === "granted" || result.state === "prompt") {
                navigator.clipboard.writeText(clippedUnit)
            }
        });
    }
    async readFromClipboard() {
        const permissionResult = await navigator.permissions.query({ name: "clipboard-read" })
        if ((permissionResult.state === "granted" || permissionResult.state === "prompt") == false) {
            return undefined
        }
        return await navigator.clipboard.readText()
    }
    // === Undo-Redo Functions === //
    saveToUndo() {
        if(this.isEditingProto()) {
            this.saveProtoUnitsToUndo()
            this.haveProtounitsBeenModified = true
        } else {
            App.game.chapter.saveStage()
            this.havePlayunitsBeenModified = true
        }
    }
        // === Undo Functions
    saveProtoUnitsToUndo() {
        this.pushProtoUnitsToUndo()
        this.clearProtoUnitsToRedo()
    }
    pushProtoUnitsToUndo() {
        const protoUnits = this.loadedProtostage.units

        this.previousProtoUnits.push(structuredClone(protoUnits))
        if(this.previousProtoUnits.length > 20) {
            this.previousProtoUnits.shift()
        }
    }
    loadProtoUnitsToUndo() {
        if(this.previousProtoUnits.length > 0) {
            this.saveProtoUnitsToRedo()
            this.loadedProtostage.units = this.previousProtoUnits.pop()

            //Audiomix.trigger("UndoAction")
            App.game.chapter.selection.reset()
            App.game.chapter.reloadStage()
        }
    }
        // === Redo Functions
    saveProtoUnitsToRedo() {
        const protoUnits = this.loadedProtostage.units

        this.nextProtoUnits.push(structuredClone(protoUnits))
    }
    loadProtoUnitsToRedo() {
        if(this.nextProtoUnits.length > 0) {
            this.pushProtoUnitsToUndo()
            this.loadedProtostage.units = this.nextProtoUnits.pop()

            //Audiomix.trigger("UndoAction")
            App.game.chapter.selection.reset()
            App.game.chapter.reloadStage()
        }
    }
    clearProtoUnitsToRedo() {
        this.nextProtoUnits = []
    }
    // === Editing Mode Booleans === //
    isFreezingPlaying() {
        return this.inProtoMode
    }
    isEditingProto() {
        return this.inProtoMode
    }
    isInspectorShowing() {
        return this.areDevPanelsOpen
    }
    isPaletteShowing() {
        return this.areDevPanelsOpen
    }
    // === Unit Creation Functions === //
    createNewUnit(newUnit) {
        this.saveToUndo()

        const player = games[App.game.slug].player
        if(player.party.units[newUnit.key] == undefined) {
            newUnit.key = shortid.generate()
        }

        if(this.isEditingProto() == true) {
            this.loadedProtostage.units[newUnit.key] = newUnit
            this.autosaveUnitsToFile()
        } else {
            App.game.chapter.stage.units[newUnit.key] = Unit.instantiate({unit: newUnit, player})
            App.game.chapter.recalculateStage()
        }
    }
    // === Cut, Copy, Paste Functions === //
    deleteSelectedUnit() {
        const selection = App.game.chapter.selection
        const key = selection.selectedUnitKey || selection.hoveredUnitKey
        if(key != undefined) {
            this.saveToUndo()
            if(this.isEditingProto() == true) {
                if(selection.multiselectedUnitKeys.size > 0) {
                    selection.multiselectedUnitKeys.forEach((anotherKey) => {
                        delete this.loadedProtostage.units[anotherKey]
                    })
                } else {
                    delete this.loadedProtostage.units[key]
                }
                this.autosaveUnitsToFile()
            } else {
                delete App.game.chapter.stage.units[key]
            }
            selection.hoveredUnitKey = undefined
            selection.selectedUnitKey = undefined
            selection.multiselectedUnitKeys.clear()
            App.game.chapter.recalculateStage()
        }
    }
    async clipUnit() {
        const selection = App.game.chapter.selection
        const unitKey = selection.selectedUnitKey || selection.hoveredUnitKey
        let selectedUnit = undefined
        if(this.inProtoMode) {
            if(selection.multiselectedUnitKeys.size > 0) {
                selectedUnit = []
                selection.multiselectedUnitKeys.forEach((key) => {
                    let unit = structuredClone(this.loadedProtostage.units[key])
                    unit.position.x -= selection.position.x
                    unit.position.y -= selection.position.y
                    selectedUnit.push(unit)
                })
            } else {
                selectedUnit = this.loadedProtostage.units[unitKey]
            }
        } else {
            selectedUnit = copyClippedUnit(App.game.chapter.stage.units[unitKey])
        }
        const stringifiedUnit = JSON.stringify(selectedUnit,undefined,4)
        this.writeToClipboard(stringifiedUnit)
    }
    async pasteUnit() {
        const clipboard = await this.readFromClipboard()
        let newUnit = undefined
        try {
            newUnit = JSON.parse(clipboard)
        } catch (error) {
            console.error("Could not parse the clipboard as JSON")
            console.error(error)
        }
        if(newUnit != undefined) {
            if(newUnit instanceof Array) {
                newUnit.forEach((unit) => {
                    unit.position.x += App.game.chapter.selection.position.x
                    unit.position.y += App.game.chapter.selection.position.y
                    unit.position.z = 1
                    this.createNewUnit(unit)
                })
            } else {
                newUnit.position = App.game.chapter.selection.position
                newUnit.position.z = 1
                this.createNewUnit(newUnit)
            }
        }
    }
    onKeyDown() {
        return async (event) => {
            event.preventDefault()
            if(event.metaKey == true
            || event.ctrlKey == true) {
                if(event.key == "s") {
                    this.saveUnitsToFile()
                }
                if(event.key == "x") {
                    this.clipUnit()
                    this.deleteSelectedUnit()
                }
                if(event.key == "c") {
                    this.clipUnit()
                }
                if(event.key == "v") {
                    this.pasteUnit()
                }
                if(event.key == "f") {
                    const element = document.getElementById("search-palette")
                    if(element != undefined) {
                        element.focus()
                    }
                }
            }
            if(this.inProtoMode == true && event.key == "z") {
                if(event.shiftKey == true) {
                    this.loadProtoUnitsToRedo()
                } else {
                    this.loadProtoUnitsToUndo()
                }
            }
        }
    }
}

// === Dev Key Combinations handler === //
document.addEventListener("keydown", dev.onKeyDown())

export default dev

// === Copying Utilities === //
function copyClippedUnit(unit) {
    if(unit == undefined) return undefined
    return {
        "key": unit.key, // unit's individual unique key
        "position": unit.position && {
            "x": unit.position.x,
            "y": unit.position.y,
            "z": unit.position.z,
        },
        "affiliation": unit.affiliation,
        "jobKey": unit.jobKey,
        "faceKey": unit.faceKey,
        "bodyKey": unit.bodyKey,
        "health": unit.health,
        "maxhealth": unit.maxhealth,
        "name": unit.name,
        "jobName": unit.jobName,
    }
}
